import React from 'react';
import {Doughnut} from 'react-chartjs';
import RaisedButton from 'material-ui/RaisedButton';

export default class Block1 extends React.Component {

    render() {
        const salaries_max = parseInt(this.props.salaries_max, 10);
        const salaries_ajoutes = parseInt(this.props.salaries_ajoutes, 10);
        const salarie_restants = salaries_max - salaries_ajoutes ;
        return (
            <div style={{marginBottom:10, marginTop:10}}>
                <div>
                    <span style={{fontSize:16, paddingLeft:18, background:'#F7464A'}}>&nbsp;</span>
                    <span> Salariés enregistrés {salaries_ajoutes}</span><br/>
                    <span style={{fontSize:16, paddingLeft:18, background:'#46BFBD'}}>&nbsp;</span>
                    <span> Salariés restants {salarie_restants}</span>
                </div>
                <div style={{
                    marginLeft:'auto',
                    marginRight:'auto',
                    marginTop:10,
                    marginBottom:10,
                    width:200
                }} >
                    <Doughnut
                        options={{
                            responsive:true,
                            legend:true
                        }}
                        data={[
                            {
                                value: salaries_ajoutes,
                                color:"#F7464A",
                                highlight: "#FF5A5E",
                                label: "Salarié ajoutés"
                            },
                            {
                                value: salarie_restants,
                                color: "#46BFBD",
                                highlight: "#5AD3D1",
                                label: "Salarié restants"
                            }
                        ]}
                        width="200"
                        height="200"/>
                </div>
                <RaisedButton
                label={'Plus de salariés'}
                primary={true}
                onClick={()=>window.alert('Pour pouvoir enregistrer plus de salariés, Veuillez nous contacter sur l\'adresse email suivante : transcendis@hotmail.fr ')}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/indexBlocks/Block2.js